/**
 * Created by Xpertiz on 21/10/2016.
 */

import { ChangeDetectionStrategy, Component, Input, EventEmitter, Output } from '@angular/core';
import { CalendarEventHolder } from '../Models/Holders/calendareventholder.model';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'notification-modal',
    templateUrl: 'notificationmodal.component.html',
    imports: [DatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class NotificationModalComponent {

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('title') modalTitle: string;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('detail') currentDetail: CalendarEventHolder[];
  @Input() type: string;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClose: EventEmitter<any> = new EventEmitter();

  closeModale() {
    this.onClose.next(true);
  }
}
